angular.module('bmsApp.settings').factory('MailchimpSvc', function ($http, $log, $window, $q, CRUDSvc) {
    var baseUrl = 'api/mailchimp/';
	return {
		verifyApiKey: function(params) {return CRUDSvc.post(baseUrl + 'verify-api-key', params);},
		getLists: function(params) {return CRUDSvc.get(baseUrl + 'get-lists', params);},
		getTemplate: function(params) {return CRUDSvc.get(baseUrl + 'get-template', params);},
		getListsInfo: function(params) {return CRUDSvc.get(baseUrl + 'get-lists-info', params);},
		removeAllListSubscribers: function(params) {return CRUDSvc.get(baseUrl + 'remove-subscribers', params);},
		importSubscribers: function(params) {return CRUDSvc.get(baseUrl + 'import-subscribers', params);},
		saveCampaign: function(params) {return CRUDSvc.get(baseUrl + 'save-campaign', params);},
		sendDraft: function(params) {return CRUDSvc.get(baseUrl + 'send-draft', params);},
		sendCampaign: function(params) {return CRUDSvc.get(baseUrl + 'send-campaign', params);}
}});




